import { Input, TemplateRef, ViewChildren, QueryList, ContentChildren, ViewChild, ElementRef, HostListener } from "@angular/core";

import * as _ from "lodash";

import { IGuide, ISelectedModule, IModule, ISelectedModuleActivity } from "../models/guide";
import { GuideService } from "../services/guide.service";
import { Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal/ngx-bootstrap-modal";
import { ScrollToService } from 'ng2-scroll-to-el';
import { IdentityService } from '../../services/identity.service';
import { Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";

export class ModuleComponent {

  @Input() data: any;
  @Input() module: string;
  @Input() activity: string;
  @Input() completed: string;

  saved: Subject<boolean> = new Subject<boolean>();

  @ViewChild('ActivityModal', { static: false }) activityModal: ElementRef;
  @ViewChild('ActivityView', { static: false }) activityView: ElementRef;
  @ViewChild('ActivitySection', { static: false }) activitySection: ElementRef;

  @HostListener('window:resize', ['$event'])
  onResize(event) {

    this.setHeight();

  }

/*  isCaseManager: boolean = false;*/

  CareerPlanPopover: string = 'Update the step for your Career Plan by:'
    + '<ul><li>Adding a date you want to begin.</li>'
    + '<li> Adding a date you plan to finish.</li>'
    + '<li> Enter the number of hours you plan to work on your step.</li>'
    + '<li> Enter any additional notes.</li>'
    + '<li> Update Status to Started / Open when you add a date.</li>'
    + '<li> Click the update button to return to the learning module.</li></ul>';

  GoalPopover: string = 'Create a Goal by:'
    + '<ul><li>Typing in something that you want to achieve</li>'
    + '<li> Select whether it applies to Career Plan, Education/Training Plan, Independent Living, Support Services, or Referral to Services</li>'
    + '<li> Select Short-term or Long-term</li>';

  titles: Array<any> = [];
  stepsMarkCompleteCaseManager: Array<string> = ["1A11", "1A21", "1A31", "1B11", "1B21", "1B31", "1C11",
    "1C21", "1C31", "1C41", "2A11", "2A21", "2A23", "2A31", "2A41", "2B11", "2B21", "2B22", "2B31",
    "2B32", "2B41", "3A11", "3A21", "3A31", "3B11", "3B21", "3C11", "3C21", "3C31"  ]

  guide: IGuide;
  activeMod: ISelectedModule;

  group: number;
  alpha: string;

  debug: boolean = false; //update this to hide module id

  loaded: boolean = false;

  modalRef: BsModalRef;
  activityModalRef: BsModalRef;

  viewActivityMode: string = "split"; //split or full

  activeActivity: string = ""; //Iframe activity

  smallScreen: boolean = false;

  showYouTube: boolean = false;

  //this is the last activity that can be selected in the learning modules
  lastActivity: string = "C41";

  constructor(private _router: Router, private scrollService: ScrollToService,
    public guideService: GuideService, public modalService: BsModalService,
    private identitySrv: IdentityService, private _toastr: ToastrService) {
  }
  ngAfterViewInit() {
    this.setHeight();
  }


  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }
  
  saveGuide() {

    this.guideService.saveGuide(this.guide).subscribe(res => {
      this.guide = res;
      this.saved.next(true);
    }, error => {

      console.log(error);
      this._toastr.error("Error saving guide");
    });
  }

  //async saveGuide() {

  //  var asyncResult = await this.guideService.saveGuide(this.guide).toPromise();
  //  console.log('No issues with save guide');
  //}

  loadGuide(loadActivity: boolean = true) {    

    this.guideService.get().subscribe(res => {
      this.guide = res;
      
      this.loaded = true;

      if (this.module != null) {
        this.activeMod.number = +this.module;
      }

      if (loadActivity) {
        this.loadActivity(this.activeMod);

        if (this.completed === "true") {
          this.markActivityComplete(this.activeActivity);
        }
        //console.log("loadGude about to setTimeout");
        setTimeout(() => {
          this.setHeight();
          this.scrollService.scrollTo("#ActivitySection");
        }, 30000); //30 seconds
      }

    });
  }

  getTitle(activityId: string) {   
    var act = _.head(this.titles.filter(f => f.activityId == activityId));

    if (act != null)
      return act.html;

    return "";
  }

  getModuleName(): string {

    var mod = this.getMod(this.activeMod);

    //console.log('Active Module', mod);

    if (mod != null) {
      return mod.name;
    }

    return "";
  }

  getGroupName(): string {

    var group = this.guide.groups[this.activeMod.group].sections.filter(f => f.alpha == this.activeMod.alpha)[0];

    //console.log('Active Group', this.group);

    return group.name;
  }


  modSelected(mod: ISelectedModule): boolean {
    return JSON.stringify(mod) === JSON.stringify(this.activeMod)
  }

  modComplete(alpha: string, number: number): boolean {

    if (this.guide == null)
      return false;    

    const mod = this.getMod({ group: this.group, alpha: alpha, number: number });

    return mod.complete;
  }

  //Checks to see if it is complete
  isActivityComplete(activityId: string): boolean {
    let result = false;
    let mod = this.getActiveMod(this.group);

    let mods = this.guide.groups[this.activeMod.group].modules.filter(f => f.alpha == this.activeMod.alpha && f.number == +activityId[1]);

    if (mods == null || mods.length <= 0) {
      return result;
    }
    if (mods[0].activities.filter(f => f.id == activityId && f.complete == true).length > 0) {
      result = true;
    };
    //  ;
    //return mods[0].activities.filter(f => f.id == activityId && f.complete == true).length > 0;
    //console.log("isActivityComplete: ", activityId, result);
    return result;
  }

  //check to see if case manager to show MarkComplete
  isCaseManager(activityId: string): boolean {
    let result = false;

    if (this.stepsMarkCompleteCaseManager.indexOf(activityId) >-1) {
      result = true;
    }
    //console.log("isCaseManager: ", activityId, result);
    return result;
  }

  // Marks an activity complete
  //HEATHER clean me up.
  markComplete(arr: object) {
    var activityIdentified = "";
    var moveNext = false;
    const activityIdObjs = Object.keys(arr).map(function (it) { return arr[it] });
    const iterator = activityIdObjs.values();

    for (const value of iterator) {
      if (typeof value !== "boolean") { activityIdentified = value }
      else { moveNext = value }
    };
    this.markActivityComplete(activityIdentified, moveNext);
  }

  markActivityComplete(activityId: string, moveNext: boolean = true) {
    let mods = this.guide.groups[this.activeMod.group].modules.filter(f => f.alpha == this.activeMod.alpha && f.number == this.activeMod.number);    

    if (mods == null || mods.length <= 0) {
      return false;
    }
    
    let act = _.head(mods[0].activities.filter(f => f.id == activityId));

    //Set the activity to completed
    act.complete = true;
    act.completed = new Date();

    //Check to see if we can mark module complete
    if (mods[0].activities.filter(f => f.complete).length == mods[0].activities.length) {
      mods[0].complete = true;
      mods[0].completed = new Date();
    }
    console.log("---> markActivityComplete calling saveGuide", activityId);

    this.saveGuide();
    this.saved.subscribe(res => {
      if (res && moveNext) {
        this.moveNextActivity(activityId);
      }
    });

    //if (moveNext) {
    //  this.moveNextActivity(activityId);
    //}
  }

  // Marks a module as complete
  complete(alpha: string, number: number) {
    //console.log('Mod Complete');
    let currentMod = this.getMod({ group: this.activeMod.group, alpha: this.activeMod.alpha, number: this.activeMod.number });
    let nextSelect = this.nextMod({ group: this.activeMod.group, alpha: this.activeMod.alpha, number: this.activeMod.number });
    let nextMod = this.getMod(nextSelect);

    currentMod.selected = false;

    if (currentMod.activities.filter(f => f.complete == false).length <= 0) {
      currentMod.complete = true;
      currentMod.completed = new Date();
    }
  
    if (nextMod != null) {

      if (this.activeMod.group != nextSelect.group || this.activeMod.alpha != nextSelect.alpha || this.activeMod.number != nextSelect.number) {
        //Redirect or emit an update        
        this.activeMod = nextSelect;
        nextMod.selected = true;

        //console.log("---> complete calling saveGuide from if", alpha, number);
        this.saveGuide();

        this._router.navigate([`/employment101/guide/${this.activeMod.group + 1}/${this.activeMod.alpha}/${this.activeMod.number}`]);
      } else {
        
        for (var i = 0; i < this.guide.groups.length; i++) {
          var group = this.guide.groups[i];

          var alphas = group.modules.map(function (v) { return v.alpha; });
          var moduleAlphaDistinct = [...new Set(alphas)];

          for (var j = 0; j < moduleAlphaDistinct.length; j++) {
            var currentAlpha = moduleAlphaDistinct[j].toString();
            var module = group.modules.filter(f => f.alpha === currentAlpha);
            var moduleCompletedLength = module.filter(f => f.complete).length;

            if (module.length === moduleCompletedLength) {
              var section = group.sections.filter(f => f.alpha === currentAlpha);
              for (var k = 0; k < section.length; k++) {
                group.sections[j].complete = true;
                group.sections[j].completed = new Date();
              }
            }
          }
        }
        //console.log("---> complete calling saveGuide from else", alpha, number);
        this.saveGuide();

        this.loadActivity(this.activeMod);
      }


    } else {
      //this._router.navigate([`/employment101/`]);
    }
  }

  setActivity(activityId: string) {
    this.activeActivity = activityId;

    //Scroll to the activity
    this.scrollService.scrollTo("#ActivitySection");

    //Update URL
    this._router.navigate([`/employment101/guide/${this.activeMod.group + 1}/${this.activeMod.alpha}/${activityId[1]}/${activityId[2]}`]);
  }

  getActiveMod(group: number): ISelectedModule {

    var mod = this.guide.groups[group].modules.filter(f => f.selected == true);

    if (mod != null && mod.length > 0) {
      return { group: group, alpha: mod[0].alpha, number: mod[0].number };
    }

    return null;
  }

  loadActivity(select: ISelectedModule) {
    
    let mod = this.getMod(select);

    if (this.activity != null) {
      //this.activeActivity = mod.alpha + mod.number + this.activity;

      this.setActivity(mod.alpha + mod.number + this.activity);
      //Set focus to the activityView
      //console.log('Scroll to Activity View');
      setTimeout(() => {        
        this.scrollService.scrollTo("#ActivitySection");
      }, 30000); // 30 seconds
    }
    else if (mod.activityId != null || mod.activityId !== "") {
      this.activeActivity = mod.activityId;
    }
  }

  stepsDisplay() {
    if (this.viewActivityMode == "split")
      return "col-md-6 steps";
    else
      return "col-md-12 steps";
  }

  activityDisplay(): string {
    if (this.viewActivityMode == "split" && !this.smallScreen)
      return "col-sm-0 col-md-6";
    else
      return "d-none";
  }

  iframeDisplay() {    

    if (this.viewActivityMode != "split" || this.smallScreen) {
      return { 'height': (window.innerHeight - 183) + 'px', 'width': '100%' };
    } else {
      return { 'height': (window.innerHeight - 60) + 'px', 'width': '100%' };
    }

  }

  setHeight() {    
    //console.log('Set Height', window.innerHeight);
    //if its not the last activity 
    if (this.activeActivity != this.lastActivity) {
      document.getElementById("ActivityView").style.height = window.innerHeight + "px";
    }
  }


  getMod(select: ISelectedModule): IModule {
    try {
      return this.guide.groups[select.group].modules.filter(f => f.alpha == select.alpha && f.number == select.number)[0];
    }
    catch (exception) {
      return null;
    }
  }

  returnToGuide() {
    this._router.navigate([`/employment101/guide`]);
  }

  movePrev() {
    this.activeMod = this.prevMod(this.activeMod);

    if (this.activeMod.group != this.group || this.activeMod.alpha != this.alpha) {
      //Redirect or emit an update
      console.log("Navigating", this.activeMod.group, this.activeMod.alpha);

      this._router.navigate([`/employment101/guide/${this.activeMod.group + 1}/${this.activeMod.alpha}`]);
    }

    this._router.navigate([`/employment101/guide/${this.activeMod.group + 1}/${this.activeMod.alpha}/${this.activeMod.number}`])    
  }

  moveNext() {

    this.activeMod = this.nextMod(this.activeMod);

    if (this.activeMod.group != this.group || this.activeMod.alpha != this.alpha) {
      //Redirect or emit an update
      console.log("Navigating", this.activeMod.group, this.activeMod.alpha);

      this._router.navigate([`/employment101/guide/${this.activeMod.group + 1}/${this.activeMod.alpha}`]);
    }

    this._router.navigate([`/employment101/guide/${this.activeMod.group + 1}/${this.activeMod.alpha}/${this.activeMod.number}`])
  }

  currentPath(activityId = '') {

    var activity = activityId.slice(-1);    

    return `/employment101/guide/${this.activeMod.group + 1}/${this.activeMod.alpha}/${this.activeMod.number}` + (activity != '' ? `/${activity}` : '');
  }

  canMoveNext(): boolean {

    var next = this.nextMod(this.activeMod);

    if (next == null)
      return false;

    //var nextMod = this.getMod(next);

    //if (nextMod.complete)
    //  return true;

    return true;
  }

  canMovePrev(): boolean {

    var prev = this.prevMod(this.activeMod);

    if (prev == null)
      return false;

    return true;
  }

  prevMod(current: ISelectedModule): ISelectedModule {

    let prev = _.cloneDeep(current);

    const currentMod = this.getMod(prev);
    let prevMod: any = null;

    if (currentMod != null) {
      //try reducing number first
      prev.number--;
      prevMod = this.getMod(prev);

      if (prevMod != null)
        return prev;

      //try prev alpha, find biggest number in series 
      prev.alpha = this.prevLetter(prev.alpha);
      prev.number = this.getLargestNumberAlphaSeries(prev);

      //console.log('Prev Letter', prev.alpha);
      prevMod = this.getMod(prev);

      if (prevMod != null)
        return prev;

      //try next group, reset alpha and number
      prev.group--;
      prev.alpha = this.getLargestAlphaSeries(prev);
      prev.number = this.getLargestNumberSeries(prev);

      prevMod = this.getMod(prev);

      if (prevMod != null)
        return prev;

      //null indicates that there is nothing left
      return null;
    }

    //CurrentMod does not exist
    return null;
  }

  nextMod(current: ISelectedModule): ISelectedModule {

    let next = _.cloneDeep(current);

    const currentMod = this.getMod(next);
    let nextMod: any = null;

    if (currentMod != null) {
      //try incrementing number first
      next.number++;
      nextMod = this.getMod(next);

      if (nextMod != null)
        return next;

      //try next alpha, reset number      
      next.number = 1;
      next.alpha = this.nextLetter(next.alpha);
      nextMod = this.getMod(next);

      if (nextMod != null)
        return next;

      //try next group, reset alpha and number
      next.number = 1;
      next.alpha = "A";
      next.group++;

      nextMod = this.getMod(next);

      if (nextMod != null)
        return next;

      //null indicates that there is nothing left
      return null;
    }

    //CurrentMod does not exist
    return null;
  }

  moveNextActivity(activityId: string) {
    var next = this.nextActivity(this.activeMod, activityId);

    if (next.activityId != null) {      

      this._router.navigate([`/employment101/guide/${next.group + 1}/${next.alpha}/${next.activityId[1]}/${next.activityId[2]}`]);
  
    } else {      

      //Current mod is complete
      this.complete(this.activeMod.alpha, this.activeMod.number);
    }
  }

  movePrevActivity(activityId: string) {
    var previous = this.prevActivity(this.activeMod, activityId);

    if (previous.activityId != null) {
      this._router.navigate([`/employment101/guide/${previous.group + 1}/${previous.alpha}/${previous.activityId[1]}/${previous.activityId[2]}`]);
    } else {
      this._router.navigate([`/employment101/guide/${previous.group + 1}/${previous.alpha}/`]);
    }

  }

  canMoveNextActivity(activityId: string): boolean {


    return this.isActivityComplete(activityId) && !(this.activeMod.group == 2 && this.activeMod.alpha == 'C' && this.activeMod.number == 4 && activityId == this.lastActivity); 

    //And not last activity in guide

    //return true
  }
  canMovePrevActivity(activityId: string): boolean {

    //Not first activity in guide
    return !(this.activeMod.group == 0 && this.activeMod.alpha == 'A' && this.activeMod.number == 1 && activityId == "A11");
  }


  prevActivity(current: ISelectedModule, activityId: string): ISelectedModuleActivity {
    let prevAct = {} as ISelectedModuleActivity;
    let currentMod = this.guide.groups[current.group].modules.filter(f => f.alpha == current.alpha && f.number == current.number);

    if (currentMod != null && currentMod.length > 0) {
      var currentActIndex = _.findIndex(currentMod[0].activities, { 'id': activityId });


      if (currentActIndex - 1 >= 0) {

        prevAct.group = current.group;
        prevAct.alpha = current.alpha;
        prevAct.number = current.number;
        prevAct.activityId = currentMod[0].activities[currentActIndex - 1].id;

      } else {
        //Need to go up the tree one

        let prevMod = this.prevMod(current);

        prevAct.group = prevMod.group;
        prevAct.alpha = prevMod.alpha;
        prevAct.number = prevMod.number;
        prevAct.activityId = null;

      }
    }

    //console.log('PrevActivity', prevAct);

    return prevAct;
  }

  nextActivity(current: ISelectedModule, activityId: string): ISelectedModuleActivity {

    let nextAct = {} as ISelectedModuleActivity;
    let currentMod = this.guide.groups[current.group].modules.filter(f => f.alpha == current.alpha && f.number == current.number);

    if (currentMod != null && currentMod.length > 0) {
      //var currentAct = currentMod[0].activities.filter(f => f.id == activityId);
      var currentActIndex = _.findIndex(currentMod[0].activities, { 'id': activityId });

      if (currentActIndex + 1 <= (currentMod[0].activities.length - 1)) {
        //See if there are anymore activities left

        //console.log('Activities List', currentMod[0].activities);
        //console.log('Indexes', currentActIndex, currentActIndex + 1);

        nextAct.group = current.group;
        nextAct.alpha = current.alpha;
        nextAct.number = current.number;
        nextAct.activityId = currentMod[0].activities[currentActIndex + 1].id;

        //console.log('NextActivity', nextAct);

        return nextAct;

      } else {
        //Find next mod, and pull first activity

        let nextMod = this.nextMod(current);

        //console.log('Next Activity - Find next mod', nextMod);


        //currentMod = this.guide.groups[nextMod.group].modules.filter(f => f.alpha == activityId[0] && f.number == +activityId[1]);
        if (nextMod != null) {
          nextAct.group = nextMod.group;
          nextAct.alpha = nextMod.alpha;
          nextAct.number = nextMod.number;
          nextAct.activityId = null;
        }
        //nextAct.activityId = currentMod[0].activities[currentActIndex + 1].id;
      }
    }
    //console.log('NextActivity', nextAct);


    return nextAct;    
  }

  getLargestAlphaSeries(select: ISelectedModule): string {

    //console.log("getLargestAlphaSeries", select);
    try {
      //let modSeries = this.guide.groups[select.group].modules.filter(f => f.alpha == select.alpha);
      var modSeries = this.guide.groups[select.group].modules;
      modSeries = _.sortBy(modSeries, ["alpha"], ["desc"]);

      if (modSeries.length === 0)
        return null;

      var index = _.findLastIndex(modSeries);

      return modSeries[index].alpha;

    }
    catch (exception) {
      return null;
    }
  }

  getLargestNumberAlphaSeries(select: ISelectedModule): number {

    try {

      var modSeries = this.guide.groups[select.group].modules.filter(f => f.alpha == select.alpha);

      if (modSeries.length === 0)
        return null;

      var index = _.findLastIndex(modSeries);

      return modSeries[index].number;

    }
    catch (exception) {
      return null;
    }
  }

  getLargestNumberSeries(select: ISelectedModule): number {

    //console.log("getLargestNumberSeries", select);

    try {

      var modSeries = this.guide.groups[select.group].modules;

      if (modSeries.length === 0)
        return null;

      var index = _.findLastIndex(modSeries);

      return modSeries[index].number;

    }
    catch (exception) {
      return null;
    }
  }


  nextLetter(s): string {
    return s.replace(/([a-zA-Z])[^a-zA-Z]*$/, function (a) {
      var c = a.charCodeAt(0);
      switch (c) {
        case 90: return null;
        case 122: return null;
        default: return String.fromCharCode(++c);
      }
    });
  }

  prevLetter(s): string {
    return s.replace(/([a-zA-Z])[^a-zA-Z]*$/, function (a) {
      var c = a.charCodeAt(0);
      switch (c) {
        case 65: return null;
        case 97: return null;
        default: return String.fromCharCode(--c);
      }
    });
  }
}
